import { useState, useEffect } from 'react';

import { createPortal } from 'react-dom';

import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

function RenderInDomNode({ children, id, refNode = null }) {
  const [elem, setElem] = useState(null);
  const { isTabletOrMobile } = useMediaBreakpoints();

  useEffect(() => {
    const staff = refNode?.current ?? document.getElementById(id);
    setElem(staff);
    return () => {
      setElem(null);
    };
  }, [isTabletOrMobile]);

  if (elem) return createPortal(children, elem);

  return null;
}

export default RenderInDomNode;
